export interface NavDetailTabs {
    icon?: string;
    path?: string;
    name?: string;
}
